module.exports = __webpack_public_path__ + "static/media/front.1e7fa2e5.jpg";